import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  extraClass = false;
  title = 'PROFETEC';

  router;

  constructor(router: Router) {
    this.router = router;
   }

  redirectTo(path: string): void {
    this.router.navigate([path]);
  }

  ham() {
    this.extraClass = !this.extraClass;

  }


}
